import { ITEM_TYPES } from 'constants/itemType';
import { NotificationPriority } from 'hooks/useNotification';
import type { UserNotificationWithDetails } from 'hooks/useUserNotifications';
import {
  formatStoreListLabel,
  storesInCone,
} from 'components/MapPage/CorporateViewTabs/LayersTab/cfa-demo/historicalHurricanesHeleneData';

/** Stable id for the hardcoded Helene stores-in-cone inbox item. */
export const HELENE_CONE_NOTIFICATION_ID = 'demo-helene-cfa-stores-in-cone';

const HELENE_CONE_SENT_AT = '2024-09-26T18:30:00.000Z';

export const HELENE_CONE_PROVENANCE = 'NHC advisory (synthetic Helene demo)';

export function isHardcodedHeleneConeNotification(
  notificationId: string | null | undefined
): boolean {
  return notificationId === HELENE_CONE_NOTIFICATION_ID;
}

export function buildHeleneConeAppMessage(): string {
  const inCone = storesInCone();
  const names = inCone.map(formatStoreListLabel).join(', ');
  return (
    `Helene forecast cone — store impact: **${inCone.length} stores** in the cone` +
    ` (${names}). SMS/email franchise operators and track prep via Response Checklist.`
  );
}

export function getHeleneConeNotification(
  groupId: string
): UserNotificationWithDetails {
  const inCone = storesInCone();
  const names = inCone.map(formatStoreListLabel).join(', ');
  const plainMessage =
    `Helene forecast cone — store impact: ${inCone.length} stores in the cone: ${names}. ` +
    `Notify franchise operators (SMS/email) and assign prep tasks in the Response Checklist.`;

  return {
    userGuid: 'system',
    notificationId: HELENE_CONE_NOTIFICATION_ID,
    groupId,
    archived: false,
    acknowledged: false,
    canArchive: false,
    createdAt: HELENE_CONE_SENT_AT,
    acknowledgedAt: null,
    archivedAt: null,
    priority: NotificationPriority.WARNING,
    status: 'sent',
    acknowledgementRequired: false,
    sourceItemId: '',
    sourceItemType: ITEM_TYPES.Sitrep,
    sentAt: HELENE_CONE_SENT_AT,
    scheduledDate: null,
    incidentId: null,
    aors: [],
    appMessage: plainMessage,
    emailSubject: `Helene cone impact — ${inCone.length} CFA stores`,
    emailMessage: plainMessage,
    smsMessage: `${inCone.length} CFA stores in Helene cone: ${names}`,
    teamsMessage: plainMessage,
    sendEmail: true,
    sendSms: true,
    sendTeams: false,
    actionType: null,
    createdByName: HELENE_CONE_PROVENANCE,
  };
}
